/* eslint-disable import/prefer-default-export */
/**
 *
 * @param {React.RefObject | String} ref React ref or string to toggle modal visibility
 * @param {Function} cb Callback function
 * @returns {void}
 */

import { logError } from '../../log/logger';

export function toggleModalVisibility(ref, cb) {
  try {
    // eslint-disable-next-line no-undef
    const element = ref?.current || document.getElementById(ref);
    if (!element) return;

    if (element.classList.contains('active')) element.classList.remove('active');
    else element.classList.add('active');

    if (cb) cb(ref);
  } catch (e) {
    logError('Modal Visibility', e);
  }
}
